/**
 * Presale Variant Updater
 * Dynamically updates presale display when customer changes variants
 * Supports hybrid variant/product level presale dates
 */

if (!customElements.get('presale-variant-updater')) {
  class PresaleVariantUpdater extends HTMLElement {
    constructor() {
      super();
      this.productData = null;
      this.currentVariantId = null;
    }

    connectedCallback() {
      this.init();
    }

    async init() {
      try {
        // Read embedded presale data from HTML
        const presaleDataScript = document.getElementById('presale-variant-data');
        if (!presaleDataScript) {
          return;
        }
        
        this.productData = JSON.parse(presaleDataScript.textContent);
        
        // Cache DOM elements
        this.presaleDisplay = document.querySelector('.preorder-info-section[data-presale-display]');
        this.presaleDateSpan = document.querySelector('[data-presale-date]');
        this.presaleProperty = document.querySelector('input[data-presale-property]');
        
        if (!this.presaleDisplay || !this.presaleDateSpan) {
          return;
        }
        
        // Listen for variant changes
        this.setupVariantListeners();
        
        // Set initial variant
        const variantInput = document.querySelector('input[name="id"]');
        if (variantInput) {
          this.currentVariantId = parseInt(variantInput.value, 10);
        }
      } catch (error) {
        // Silently fail - presale functionality is optional
      }
    }

    setupVariantListeners() {
      // Listen for the theme's product:variant-change event
      document.addEventListener('product:variant-change', (e) => {
        if (e.detail && e.detail.variant && e.detail.variant.id) {
          const newVariantId = e.detail.variant.id;
          if (newVariantId !== this.currentVariantId) {
            this.currentVariantId = newVariantId;
            this.updatePresaleDisplay(newVariantId);
          }
        }
      });

      // Also listen for standard input changes as fallback
      const variantSelectors = document.querySelectorAll('input[name="id"], select[name="id"]');
      
      variantSelectors.forEach(selector => {
        selector.addEventListener('change', (e) => {
          const newVariantId = parseInt(e.target.value, 10);
          if (newVariantId !== this.currentVariantId) {
            this.currentVariantId = newVariantId;
            this.updatePresaleDisplay(newVariantId);
          }
        });
      });
    }

    updatePresaleDisplay(variantId) {
      if (!this.productData) return;

      // Find the variant in product data
      const variant = this.productData.variants.find(v => v.id === variantId);
      if (!variant) return;

      // Check variant-level presaleDate first, fall back to product-level
      const presaleDate = variant.presaleDate || this.productData.productPresaleDate;

      // Update display elements
      if (presaleDate && presaleDate !== '') {
        // Update text
        this.presaleDateSpan.textContent = presaleDate;
        this.presaleDisplay.style.display = 'block';
        
        // Update hidden input - set value and enable name attribute so it submits
        if (this.presaleProperty) {
          this.presaleProperty.value = `Expected to Ship ${presaleDate}`;
          this.presaleProperty.setAttribute('name', 'properties[Presale]');
        }
      } else {
        // Hide display and clear input
        this.presaleDisplay.style.display = 'none';
        
        // Remove name attribute so empty value doesn't submit to cart
        if (this.presaleProperty) {
          this.presaleProperty.value = '';
          this.presaleProperty.removeAttribute('name');
        }
      }
    }
  }

  customElements.define('presale-variant-updater', PresaleVariantUpdater);
}

// Auto-initialize if product page
if (document.querySelector('form[action*="/cart/add"]')) {
  const updater = document.createElement('presale-variant-updater');
  document.body.appendChild(updater);
}
